import { message } from "antd";
import { REFRESH_CACHE_FOR_BOARDING_POINTS_URL, REFRESH_CACHE_FOR_DROP_POINTS_URL } from "../../../utils/api-url";
import { AGENT_TO_VIEW_NEW_TIMING_TAB, AGENT_TO_VIEW_PASSENGER_TAB, AGENT_TO_VIEW_LOGS_TAB, VIEW_ADMIN_TAB_IN_SEARCH_PAGE, ADMIN_CHANGE_SEAT_LAYOUT } from "../../../utils/constant"
import { postCall } from "../../../utils/network.util";
import { checkActionAllowed, isValid, isValidArray } from "../../../utils/utilities"
import { getSharingAgentActions } from "../../../actions/service-sharing.actions";

/*
  Sharing agent actions per owner operator, cached for the session so every
  shared trip card of the same owner does not refetch.
*/
let sharingActionsCache = {};
export const fetchSharingActionsForOperator=(ownerOperatorCode,onDone=()=>{})=>{
    if(isValid(sharingActionsCache[ownerOperatorCode])){
        onDone(sharingActionsCache[ownerOperatorCode]);
        return;
    }
    getSharingAgentActions(ownerOperatorCode,(actions)=>{
        sharingActionsCache[ownerOperatorCode] = isValid(actions)?actions:{};
        onDone(sharingActionsCache[ownerOperatorCode]);
    },()=>{
        sharingActionsCache[ownerOperatorCode] = {};
        onDone(sharingActionsCache[ownerOperatorCode]);
    });
}

export const getShowTicketsConfirmation=(checkFn=checkActionAllowed)=>{
    if(checkFn(AGENT_TO_VIEW_PASSENGER_TAB)){
        return true;
    }else{
        return false;
    }
}

export const getShowNewTiming=(schedule,checkFn=checkActionAllowed)=>{
    if(checkFn(AGENT_TO_VIEW_NEW_TIMING_TAB)&&isValidArray(schedule.pickupTimings)&&isValidArray(schedule.pickupTimings[0])&&isValid(schedule.pickupTimings[0].trip_id)){
        return true;
    }else{
        return false;
    }
}

export const isLogsTabAllowed = (checkFn=checkActionAllowed)=> {
    if(checkFn(AGENT_TO_VIEW_LOGS_TAB)){
        return true;
    }else{
        return false;
    }
}

export const isAdminTabAllowed = (checkFn=checkActionAllowed)=> {
    if(checkFn(VIEW_ADMIN_TAB_IN_SEARCH_PAGE)){
        return true;
    }else{
        return false;
    }
}


export const refreshBoardingPoints = (scheduleId,tripId,onSuccess=()=>{},onFailure=()=>{}) =>{
    postCall(REFRESH_CACHE_FOR_BOARDING_POINTS_URL,{scheduleId,tripId})
    .then((findresponce) =>
      {
        if(findresponce.status === "SUCCESS"){
           message.success(findresponce.payload);
         }
      })
}

export const refreshDropPoints = (scheduleId,tripId,onSuccess=()=>{},onFailure=()=>{}) =>{
    postCall(REFRESH_CACHE_FOR_DROP_POINTS_URL,{scheduleId,tripId})
    .then((findresponce) =>
      {
        if(findresponce.status === "SUCCESS"){
            message.success(findresponce.payload);
          }
      })
}